import type * as React from 'react'

import {
  Paragraph,
  Strong,
  Text,
  Textarea,
  TriangleAlertIcon,
} from '@buffer-mono/popcorn'

import styles from './PromptTextarea.module.css'

import type { JSX } from 'react'

/**
 *
 */
function PromptTextarea({
  id,
  name,
  value,
  errorMessage,
  tip,
  placeholder,
  testId,
  onChange,
}: {
  id?: string
  name?: string
  value?: string
  errorMessage?: React.ReactNode
  tip?: React.ReactNode
  placeholder?: string
  testId?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}): JSX.Element {
  const accessibleDescriptionId = `${id}-description`
  const isInvalid = !!errorMessage

  return (
    <>
      <Textarea
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        data-testid={testId}
        aria-invalid={isInvalid}
        aria-describedby={accessibleDescriptionId}
        rows={6}
        resize="none"
        className={styles.textarea}
      />

      {errorMessage && (
        <Text
          as="div"
          id={accessibleDescriptionId}
          size="sm"
          color="critical"
          icon={<TriangleAlertIcon size="xsmall" />}
          className={styles.error}
        >
          {errorMessage}
        </Text>
      )}

      {tip && !isInvalid && (
        <Paragraph size="sm">
          <Strong>Pro tip:</Strong> {tip}
        </Paragraph>
      )}
    </>
  )
}

export { PromptTextarea }
